<template>
  <div class="main-box">
    <ball></ball>
    <van-nav-bar
        title="住院记录"
        left-arrow
         left-text="返回"
        @click-left="onClickLeft"
      />
         <van-notice-bar
        left-icon="volume-o"
        text="点击住院记录卡片进入缴费页"
      />
    <div class="cell">
       
      <div
        class="item"
        size="large"
        v-for="(item, index) in hospitalizationList"
        :key="index"
        @click="goCarddetails(item)"
        v-if="item.state==1"
      >
        <div class="cell_item">
          <div class="title">{{ item.clientName }}</div>
          <div class="value">住院号: {{ item.inPatientId }}</div>
          
        </div>
        <div class="cell_item">
          <div class="value">入院时间:{{ item.hospitalizedDate }}</div>
          <div class="value">科室: {{ item.deptName}}</div>
          <!-- class="btn_mini_style" -->
          <!-- <div>
            <van-button
              color="#5B8DF6"
              size="small"
              class="btn_mini_style"
              round
              @click.stop="query(item.medCardNo)"
              >查看</van-button
            >
          </div> -->
        </div>
      </div>
    </div>
    <van-empty
      v-if="hospitalizationList.length === 0"
      image="https://account.kmmds.top/datainfo_pic/error.png"
      description="该就诊人没有住院记录"
    />
    
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import { Dialog } from "vant";
export default {
  mixins: [setOptions],
  data() {
    return {
      navTitle: "就诊卡列表",
      hospitalizationList: [],
      isLoad: true,
      medCardNo: "",
      test:{a:0.01}
    };
  },
  components: {
    Nav,
  },
  mounted(){
     if (this.$route.query) {
      //  console.log(this.$route.query);
      this.clientId = this.$route.query.clientId;
      this.name = this.$route.query.name
    }
    if (!this.clientId || this.clientId == "") {
      // this.Dialog();
      this.$router.push('/patient_card_confUser_C')
      return;
    }
    this.gethospitalization();
  },
  created() {
    // console.log((this.test['a']) == 'string'&&this.test['a'].indexOf(".000Z")==-1)
  },
  methods: {
    onClickLeft(){
       this.$router.push('/index')
    },
    //
    //跳转详情页
    goCarddetails(item) {
      // console.log(item.state)
        let  EndDate
      if(item.state==1 ||item.state ==0 || item.state==5 ||!item.disChargeDate){
           EndDate=new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() +" 23:59:59"
      }else{
        EndDate=item.disChargeDate
      }
      this.$router.push({
        path: "/payRank",
        query: {
            clientId:item.medCardNo,
          InPatientId: item.inPatientId,
          clientName:item.clientName,
          deptId:item.deptId
        },
      });
    },
    async gethospitalization() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/queryinpatient";
        let data = {
          // clientId:"00004462"
          clientId:this.clientId
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (resultdata) => {
            this.$hideLoad();
            if(resultdata&&resultdata.data){
              this.hospitalizationList = resultdata.data.data.data;
            }
            console.log(this.hospitalizationList);
            // Dialog.alert({
            //   message:
            //     "该公众号目前数据均为测试数据，你所录入的数据也将录入测试数据",
            // }).then(() => {
            //   // on close
            // });
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 100vw;
  height: 100vh;
  background: white;

  .nav {
    margin-bottom: 8px;
  }
  .cell {
    display: flex;
    flex-direction: column;
    width: 93%;
    margin: 0px auto;
    margin-top:1vh ;
    .cell_item {
      display: flex;
      flex-direction: row;
      line-height: 40px;
      justify-content: space-between;
      margin-left: 10px;
      margin-right: 10px;
      .title {
        font-size: 18px;
        color: #323233;
      }
      .value {
        font-size: 15px;
        color: #555;
      }
      .label {
        font-size: 15px;
        color: #999;
      }
    }
    // margin-top: 15px;
  }
  .item {
    display: flex;
    flex-direction: column;
    padding-top: 16px;
    padding-bottom: 16px;
    &::after {
      border-bottom: 0;
    }
    margin-bottom: 15px;
    background-color: #f7f8fa;
    box-shadow: 0 8px 12px #ebedf0;
    border-radius: 8px;
  }

  .btn-box {
    .btn {
      margin-left: 40px;
    }
  }
}
.cell_box {
  display: flex;
  flex-direction: column;
}
.mar {
  margin-top: 10px;
}
.submit {
  margin: 55px 20px 25px 20px;
}
.Btn_style {
  width: 100%;
  // margin: 0px auto;
  position: fixed;
  bottom: 0vh;
  display: flex;
  flex-direction: column;
  justify-self: center;
  align-items: center;
  height: 70px;
  background-color: #ffffff;
  border-top: 1px solid #aaaaaa;
  .btn {
    width: 95%;
    letter-spacing: 10px;
    font-size: 16px;
    margin: 10px auto;
    background-color:#5B8DF6;
  }
}
.btn_mini_style {
  width: 80px;
  height: 25px;
  letter-spacing: 7px;
}
 .van-button--round {
  border-radius: 10px;
}
</style>